export default ({ $axios, $sitewideData, $integrationsManager }) => {
    let api = null

    const yotpo = new $integrationsManager.loaders.OnDemandLoader([
        {
            src: `https://staticw2.yotpo.com/${$sitewideData.config.yotpoApiKey}/widget.js`,
        },
    ])

    yotpo.getCustomerPhotos = async (yotpoId) => {
        try {
            const { data } = await $axios.get(
                `https://api.yotpo.com/v1/widget/${$sitewideData.config.yotpoApiKey}/albums/product/${yotpoId}?page=1&per_page=3`
            )
            if (!data || !data.response || data.response.images.length < 3) return false
            return true
        } catch (err) {
            if (err && err.response) console.error('get customer photos error', err.response.data)
        }
    }

    yotpo.getApi = () => {
        if (!api) api = new window.Yotpo.API(window.yotpo)
        return api
    }

    return yotpo
}
